import { MAIL_RULE_TEMPLATES } from './mailRuleTemplateData';
import './MailRuleForm.css';
import './MailRuleTemplates.css';

/**
 * 右欄沒在新增時的「快速建立」面板（AGUI-1113）。取代原本只寫一行「按「＋」新增規則」的虛線框。
 *
 * 還沒有任何規則時標題改成「建立第一條規則」，讓第一次進來的人知道下一步做什麼；
 * 已有規則時同一塊繼續當範本入口。規則已達上限時整塊停用並說明原因。
 *
 * @param {number|null} ruleCount 目前的規則數；null＝還在載入
 * @param {number} maxRules 規則上限
 * @param {Function} onPick 選了範本：onPick(template)；自己設定：onPick(null)
 * @param {boolean} [disabled] 頁面處理中：與左欄「＋」一起鎖住（情境 L）
 */
export default function MailRuleTemplates({ ruleCount, maxRules, onPick, disabled = false }) {
  const full = ruleCount !== null && ruleCount >= maxRules;
  const locked = full || disabled;
  const first = ruleCount === 0;

  return (
    <section className="mail-rule-templates" aria-labelledby="mail-rule-templates-title">
      {/* 沿用表單的標題列與標題樣式，換成表單時標題停在同一個位置 */}
      <div className="mail-rule-form__header">
        <h3 id="mail-rule-templates-title" className="mail-rule-form__title">
          {first ? '建立第一條規則' : '新增規則'}
        </h3>
      </div>
      {/* 上限是 MyAgent 與本頁合計（C12a）；10-19 PO 檢視：畫面上不提 MyAgent */}
      <p className="mail-rule-templates__desc">
        {full
          ? `已達 ${maxRules} 條規則上限，請先刪除不用的規則。`
          : '常用情境推薦，快速設定規則'}
      </p>

      <div className="mail-rule-templates__list">
        {MAIL_RULE_TEMPLATES.map((t) => (
          <button
            key={t.id}
            type="button"
            className="mail-rule-templates__item"
            disabled={locked}
            onClick={() => onPick(t)}
          >
            <span className="mail-rule-templates__item-title">
              {t.title}
              {t.ai && <span className="mail-rule-form__ai-badge">AI</span>}
            </span>
            <span className="mail-rule-templates__item-desc">{t.desc}</span>
          </button>
        ))}
        {/* 10-06：原本是底下一行底線連結，和範本卡風格不一致；改成同尺寸的卡片補進格子，用虛線框和範本區分 */}
        <button
          type="button"
          className="mail-rule-templates__item mail-rule-templates__item--blank"
          aria-label="不用範本，自己設定條件"
          disabled={locked}
          onClick={() => onPick(null)}
        >
          <span className="mail-rule-templates__blank-title">＋ 自己設定條件</span>
          <span className="mail-rule-templates__item-desc">不用範本，從空白表單開始</span>
        </button>
      </div>
    </section>
  );
}
